module.exports = __webpack_public_path__ + "6267-shadow.4d92d7692f598bc6fbb67314ea613b87.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6267-shadow.png
// module id = 92
// module chunks = 0